module.exports = __webpack_public_path__ + "static/media/pickled_assorted.732c0fee.png";